<template>
  <div class="icon-manager" style="display: none" id="icon_manager_dialog">
    <div class="icon-manager-close" onclick="closeIconManagerDialog()">
      <i icon="close circle"></i>
    </div>
    <div class="icon-manager-content shadow">
      <div class="icon-manager-center">
        <div class="icon-manager-search">
          <input type="text" id="icon_search" oninput="search_icon(this.value)" placeholder="search icon" />
          <div class="custom-select">
            <select onchange="iconOptionsChnaged(this)">
              <option>Ant Icons</option>
              <option>Box Icons</option>
              <option>Clarity Icons</option>
            </select>
          </div>
        </div>
        <div class="icon-canvas">
          <span class="loader2" id="icon_loader"></span>
          <iframe id="icon_canvas_frame"></iframe>
          <div id="icon_canvas_bottom_actions" class="bottom-actions">
            Icon:
            <div id="ic_mngr_icon" class="icon">
              <i icon="close"></i>
            </div>
            Fill:
            <div id="ic_mngr_color" class="square" color>
              <input type="text" class="coloris instance2" data-coloris list="ic_mngr_color_list" oninput="icmngr_fill_change(this)" />
            </div>
            stroke:
            <div id="ic_mngr_stroke" class="square" color>
              <input type="text" class="coloris instance2" data-coloris list="ic_mngr_stroke_list" oninput="icmngr_stroke_change(this)" />
            </div>
            <button class="btn btn-secondary ml-auto" onclick="icmngr_Clear()">Clear</button>
            <button class="btn btn-primary" onclick="icmngr_Insert()">Insert</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
